import { createContext, useContext, useMemo } from 'react'
import PropTypes from 'prop-types'

const AnalyseStateContext = createContext({ value: {} })

AnalyseStateContext.displayName = 'AnalyseStateContext'

export function AnalyseContextProvider(props) {
  const value = useMemo(() => props.value, [props.value])

  return <AnalyseStateContext.Provider value={value} {...props} />
}

AnalyseContextProvider.propTypes = {
  value: PropTypes.object.isRequired
}

export function useAnalyseContext() {
  const context = useContext(AnalyseStateContext)

  if (!context) {
    throw new Error('useAnalyseContext must be used within a AppProvider')
  }

  return context
}
